import cn from 'classnames';
import { FC } from 'react';

import { Icon } from '@/shared/ui';

import styles from './SortArrows.module.scss';

type SortArrowsProps = {
  sortDirection: 'asc' | 'desc' | false;
  className?: string;
};

export const SortArrows: FC<SortArrowsProps> = ({
  sortDirection,
  className,
}) => (
  <div className={cn(styles.arrowIconsWrapper, className)}>
    <Icon
      name="arrowUp2"
      size={8}
      className={cn(
        styles.arrowIcon,
        sortDirection === 'desc' && styles.activeIcon,
      )}
    />
    <Icon
      name="arrowDown2"
      size={8}
      className={cn(
        styles.arrowIcon,
        sortDirection === 'asc' && styles.activeIcon,
      )}
    />
  </div>
);
